import React from "react";
import PathConstants from "./path-constants";

// Setup Flow

const UploadInsuranceCard = React.lazy(
  () => import("../pages/product/setup-flow/upload-insurance-card"),
);
const UploadProcessing = React.lazy(
  () => import("../pages/product/setup-flow/upload-processing"),
);
const ConfirmInsuranceDetails = React.lazy(
  () => import("../pages/product/setup-flow/confirm-insurance-details"),
);
const PrimaryEnrollee = React.lazy(
  () => import("../pages/product/setup-flow/primary-enrollee"),
);
const DenyingPartyPage = React.lazy(
  () => import("../pages/product/setup-flow/denying-party-page"),
);
const OtherAppealSituationsPage = React.lazy(
  () => import("../pages/product/setup-flow/other-appeal-situations-page"),
);

// Experience Flow

const AppealSurvey = React.lazy(
  () => import("../pages/product/experience-flow/appeal-survey"),
);
const SurveyJs = React.lazy(
  () => import("../pages/product/experience-flow/survey-js"),
);
const ExperienceOverview = React.lazy(
  () => import("../pages/product/experience-flow/experience-overview"),
);
const ExperienceSummary = React.lazy(
  () => import("../pages/product/experience-flow/experience-summary"),
);

// Letter Creation Flow

const LetterBuildingInterstitial = React.lazy(
  () =>
    import("../pages/product/letter-creation-flow/letter-building-interstitial"),
);
const AppealOverview = React.lazy(
  () => import("../pages/product/letter-creation-flow/appeal-overview"),
);
const PreviewComplete = React.lazy(
  () => import("../pages/product/letter-creation-flow/preview-complete"),
);
const PreviewAndReviewAppealLetter = React.lazy(
  () =>
    import("../pages/product/letter-creation-flow/preview-and-review-appeal-letter"),
);
const UploadAdditionalDocumentsPage = React.lazy(
  () =>
    import("../pages/product/letter-creation-flow/upload-additional-documents"),
);
const GatherPatientData = React.lazy(
  () =>
    import("../pages/product/letter-creation-flow/patient-data/patient-data"),
);
const AppealDepartment = React.lazy(
  () =>
    import("../pages/product/letter-creation-flow/appeal-department/appeal-department"),
);
const EmployerAddress = React.lazy(
  () => import("../pages/product/letter-creation-flow/employer-address"),
);
const CcDestinations = React.lazy(
  () =>
    import("../pages/product/letter-creation-flow/cc-destinations/cc-destinations"),
);

// Payment Flow

const PrePayment = React.lazy(
  () => import("../pages/product/payment-flow/pre-payment/pre-payment"),
);
const ReadyToSubmit = React.lazy(
  () => import("../pages/product/payment-flow/ready-to-submit/ready-to-submit"),
);
const ReviewAppeal = React.lazy(
  () => import("../pages/product/payment-flow/review-appeal/review-appeal"),
);
const AppealSubmitting = React.lazy(
  () =>
    import("../pages/product/payment-flow/appeal-submitting/appeal-submitting"),
);
const PaymentComplete = React.lazy(
  () =>
    import("../pages/product/payment-flow/payment-complete/payment-complete"),
);

const NotFound = React.lazy(() => import("../pages/product/error/not-found"));

const routes = [
  { path: PathConstants.UploadInsuranceCard, element: <UploadInsuranceCard /> },
  {
    path: PathConstants.UploadProcessing,
    element: <UploadProcessing />,
    className: "body_background_almost_black",
  },
  {
    path: PathConstants.ConfirmInsuranceDetails,
    element: <ConfirmInsuranceDetails />,
    className: "background_white",
  },
  {
    path: PathConstants.PrimaryEnrollee,
    element: <PrimaryEnrollee />,
    className: "background_white",
  },
  {
    path: PathConstants.DenyingPartyPage,
    element: <DenyingPartyPage />,
    className: "background_white",
  },
  {
    path: PathConstants.OtherAppealSituationsPage,
    element: <OtherAppealSituationsPage />,
    className: "background_white",
  },
  {
    path: PathConstants.ExperienceOverview,
    element: <ExperienceOverview />,
    className: "body_background_light-volt-fade-down",
  },
  { path: PathConstants.AppealSurvey, element: <AppealSurvey /> },
  { path: PathConstants.SurveyJs, element: <SurveyJs /> },
  {
    path: PathConstants.ExperienceSummary,
    element: <ExperienceSummary />,
    className: "body_background_light-volt-fade-down",
  },
  {
    path: PathConstants.LetterBuildingInterstitial,
    element: <LetterBuildingInterstitial />,
    className: "body_background_almost_black",
  },
  { path: PathConstants.AppealOverview, element: <AppealOverview /> },
  {
    path: PathConstants.PreviewComplete,
    element: <PreviewComplete />,
    className: "body_background_light-volt-fade-down",
  },
  {
    path: PathConstants.PreviewAndReviewAppealLetter,
    element: <PreviewAndReviewAppealLetter />,
  },
  {
    path: PathConstants.UploadAdditionalDocuments,
    element: <UploadAdditionalDocumentsPage />,
  },
  { path: PathConstants.PatientData, element: <GatherPatientData /> },
  {
    path: PathConstants.AppealDepartment,
    element: <AppealDepartment />,
  },
  {
    path: PathConstants.EmployerAddress,
    element: <EmployerAddress />,
  },
  { path: PathConstants.CcDestinations, element: <CcDestinations /> },
  { path: PathConstants.PrePayment, element: <PrePayment /> },
  { path: PathConstants.ReadyToSubmit, element: <ReadyToSubmit /> },
  { path: PathConstants.ReviewAppeal, element: <ReviewAppeal /> },
  { path: PathConstants.AppealSubmitting, element: <AppealSubmitting /> },
  { path: PathConstants.PaymentComplete, element: <PaymentComplete /> },
  { path: PathConstants.NotFound, element: <NotFound /> },
];

export default routes;
